<template>
  <tr
    :key="index"
    :style="{ cursor: 'pointer', backgroundColor: index % 2 === 0 ? '#EEEEEE' : '#FFF',  }"
    :class="selectedRow === index ? 'indigo lighten-4' : ''"
    @click="selectRow(index)"
  >
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.source_onboarding_name }}
    </td>
    <td
      v-if="
        menuType === 'subMerchantClient' || menuType === 'subMerchantInputer'
      "
      class="d-block d-sm-table-cell d-print-table-cell"
      style="white-space: pre"
    >
      {{ item.aggregator_name }}
    </td>
    <td
      class="d-block d-sm-table-cell d-print-table-cell"
      style="white-space: pre"
    >
      {{ item.merchant_name }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.mid }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.nmid }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.mpan }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.address }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.merchant_criteria }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.mobile_phone }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.qr_type }}
    </td>
    <td v-if=" menuType !== 'merchantClient' && menuType !== 'outletClient' && menuType !== 'subMerchantClient'" class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.sn }}
    </td>
    <td
      v-if="
        menuType === 'outletClient' ||
        menuType === 'merchantClient' ||
        menuType === 'subMerchantClient'
      "
      class="d-block d-sm-table-cell d-print-table-cell"
    >
      {{ item.settlement_type_name }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.created_at }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.deactivated_at }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.status }}
    </td>
    <td
      v-if="menuType === 'merchantClient' || menuType === 'subMerchantClient'"
      class="d-block d-sm-table-cell d-print-table-cell"
    >
      <v-menu offset-y rounded="lg" transition="slide-y-transition" bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="warning"
            class="mb-2"
            icon
            dark
            v-bind="attrs"
            v-on="on"
          >
            <v-icon light size="20">mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item link :to="`/client/merchant/view/${item.id}`">
            <v-list-item-icon>
              <v-icon>mdi-eye</v-icon>
            </v-list-item-icon>
            <v-list-item-title>View Merchant</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="listItem(item)">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List Outlet</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </td>

    <td
      v-if="menuType === 'merchantInputer' || menuType === 'subMerchantInputer'"
      class="d-block d-sm-table-cell d-print-table-cell"
    >
      <v-menu offset-y rounded="lg" transition="slide-y-transition" bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="warning"
            class="mb-2"
            icon
            dark
            v-bind="attrs"
            v-on="on"
          >
            <v-icon light size="20">mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item link :to="`/inputer/merchant/view/${item.id}`">
            <v-list-item-icon>
              <v-icon>mdi-eye</v-icon>
            </v-list-item-icon>
            <v-list-item-title>View Merchant</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="editItem(item)"
            :disabled="
              item.status.toLowerCase() == 'closed' ||
              item.status.toLowerCase() == 'blocked'
            "
          >
            <v-list-item-icon>
              <v-icon :disabled="item.status.toLowerCase() == 'closed'"
                >mdi-pencil</v-icon
              >
            </v-list-item-icon>
            <v-list-item-title>Edit Data PTEN</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="editItemNon(item)"
            :disabled="
              item.status.toLowerCase() == 'closed' ||
              item.status.toLowerCase() == 'blocked'
            "
          >
            <v-list-item-icon>
              <v-icon :disabled="item.status.toLowerCase() == 'closed'"
                >mdi-pencil</v-icon
              >
            </v-list-item-icon>
            <v-list-item-title>Edit Data non PTEN</v-list-item-title>
          </v-list-item> 
          <v-list-item @click="openSerialNumberDialog(item)">
            <v-list-item-icon>
              <v-icon>{{ serialIcon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ serialTitle }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item link @click="listItem(item)">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List Outlet</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="closeMerchant(item)"
            :disabled="
              item.status.toLowerCase() == 'closed' ||
              item.status.toLowerCase() == 'blocked'
            "
          >
            <v-list-item-icon>
              <v-icon :disabled="item.status.toLowerCase() == 'closed'"
                >mdi-delete</v-icon
              >
            </v-list-item-icon>
            <v-list-item-title
              >Close
              {{
                menuType === 'merchantInputer' ? 'Merchant' : 'Sub Merchant'
              }}</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            link
            @click="blockUnblockMerchant(item)"
            :disabled="item.status.toLowerCase() == 'closed'"
          >
            <v-list-item-icon>
              <v-icon :disabled="item.status.toLowerCase() == 'closed'"
                >mdi-close-octagon</v-icon
              >
            </v-list-item-icon>
            <v-list-item-title>Block/Unblock Merchant</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </td>

    <td
      v-if="menuType === 'outletClient'"
      class="d-block d-sm-table-cell d-print-table-cell"
    >
      <v-menu offset-y rounded="lg" transition="slide-y-transition" bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="warning"
            class="mb-2"
            icon
            dark
            v-bind="attrs"
            v-on="on"
          >
            <v-icon light size="20">mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item link @click="viewItem(item)">
            <v-list-item-icon>
              <v-icon>mdi-eye</v-icon>
            </v-list-item-icon>
            <v-list-item-title>View Merchant</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['options', 'selectedRow', 'item', 'index'],
  methods: {
    viewItem(item) {
      this.$emit('viewItemParent', item);
    },
    selectRow(index) {
      this.$emit('selectRowParent', index);
    },
    listItem(itemId) {
      this.$emit('listItemParent', itemId);
    },
    editItem(item) {
      this.$emit('editItemParent', item);
    },
    editItemNon(item) {
      this.$emit('editItemNonParent', item);
    },
    closeMerchant(item) {
      this.$emit('closeMerchantParent', item);
    },
    blockUnblockMerchant(item) {
      this.$emit('blockUnblockMerchantParent', item);
    },
    openSerialNumberDialog(item) {
      this.$emit('openSerialNumberDialogParent', item);
    },
  },
  computed: {
    menuType() {
      let type;
      switch (this.$route?.name) {
        case 'Merchant':
          type = 'merchantClient';
          break;
        case 'SubMerchant':
        case 'AllSubMerchant':
          type = 'subMerchantClient';
          break;
        case 'AllSubMerchantOutlet':
        case 'SubMerchantOutlet':
        case 'ListOutletMerchant':
          type = 'outletClient';
          break;
        case 'InputerMerchant':
          type = 'merchantInputer';
          break;
        case 'InputerAllSubMerchant':
        case 'InputerSubMerchant':
          type = 'subMerchantInputer';
          break;
        default:
          type = 'nonMerchant';
          break;
      }

      return type;
    },
    serialIcon() {
      return this.item.sn === null || this.item.sn === '' ? 'mdi-plus' : 'mdi-pencil';
    },
    serialTitle() {
      return this.item.sn === null || this.item.sn === '' ? 'Add Serial Number' : 'Edit Serial Number';
    }
  },
};
</script>
